<form [formGroup]="opportunityForm" class="container-fluid wave-background wave-background-thin">
  <div class="row mb-4">
    <div class="col">
      <h1 class="text-white py-4">Crea Opportunità</h1>
    </div>
  </div>
  <div class="row">
    <div class="form-group col-md-4 mb-3">
      <label for="Nome_richiedente__c" class="form-label">Nome richiedente</label>
      <input
        [class.is-invalid]="opportunityForm.get('Nome_richiedente__c').invalid && opportunityForm.get('Nome_richiedente__c').touched"
        readonly type="text" class="form-control" id="Nome_richiedente__c" placeholder="Nome richiedente"
        formControlName="Nome_richiedente__c" maxlength="255" />
    </div>
    <div class="form-group col-md-4 mb-3">
      <label for="Email_richiedente__c" class="form-label">Email Richiedente</label>
      <input readonly
        [class.is-invalid]="opportunityForm.get('Email_richiedente__c').invalid && opportunityForm.get('Email_richiedente__c').touched"
        type="email" class="form-control" id="Email_richiedente__c" placeholder="Email Richiedente"
        formControlName="Email_richiedente__c" />
    </div>
    <div class="form-group col-md-4 mb-3">
      <label for="Ruolo_richiedente__c" class="form-label">Ruolo Richiedente <i class="text-danger">*</i></label>

      <ng-select [items]="roles$ | async" #select bindLabel="Ruolo Richiedente" dropdownPosition="auto"
        bindValue="value" bindLabel="label" labelForId="Ruolo_richiedente__c" placeholder="Ruolo Richiedente"
        [virtualScroll]="true" formControlName="Ruolo_richiedente__c">
      </ng-select>
    </div>
  </div>
  <div class="row">
    <div class="form-group col-md-4 mb-3">
      <label for="Nome_Cliente__c" class="form-label">Nome Cliente <i class="text-danger">*</i></label>
      <input
        [class.is-invalid]="opportunityForm.get('Nome_Cliente__c').invalid && opportunityForm.get('Nome_Cliente__c').touched"
        type="text" class="form-control" id="Nome_Cliente__c" placeholder="Nome Cliente"
        formControlName="Nome_Cliente__c" maxlength="255" />
    </div>
    <div class="form-group col-md-4 mb-3">
      <label for="Codice_Fiscale_Cliente__c" class="form-label">Codice Fiscale Cliente <i
          class="text-danger">*</i></label>
      <input
        [class.is-invalid]="opportunityForm.get('Codice_Fiscale_Cliente__c').invalid && opportunityForm.get('Codice_Fiscale_Cliente__c').touched"
        type="email" class="form-control" id="Codice_Fiscale_Cliente__c" placeholder="Codice Fiscale Cliente"
        formControlName="Codice_Fiscale_Cliente__c" maxlength="55" />
    </div>
  </div>

  <div class="row">
    <div class="form-group col-md-4 mb-3">
      <label for="ID_Opp_Noovle__c" class="form-label">ID Opp Noovle</label>
      <input
        [class.is-invalid]="opportunityForm.get('ID_Opp_Noovle__c').invalid && opportunityForm.get('ID_Opp_Noovle__c').touched"
        type="text" class="form-control" id="ID_Opp_Noovle__c" placeholder="ID Opp Noovle"
        formControlName="ID_Opp_Noovle__c" maxlength="20" />
    </div>
    <div class="form-group col-md-4 mb-3">
      <label for="ID_SDW__c" class="form-label">ID SDW <i class="text-danger">*</i></label>
      <input [class.is-invalid]="opportunityForm.get('ID_SDW__c').invalid && opportunityForm.get('ID_SDW__c').touched"
        type="text" class="form-control" id="ID_SDW__c" placeholder="ID SDW" formControlName="ID_SDW__c"
        maxlength="20" />
    </div>
  </div>

  <div class="row">
    <div class="form-group col-md-4 mb-3">
      <label for="Tipologia_Opportunit__c" class="form-label">Tipologia Opportunità <i class="text-danger">*</i></label>

      <ng-select [items]="opportunityType$ | async" #select bindLabel="Line of Tipologia_Opportunit__c"
        dropdownPosition="auto" bindValue="value" bindLabel="label" labelForId="Tipologia_Opportunit__c"
        placeholder="Tipologia Opportunità" [virtualScroll]="true" formControlName="Tipologia_Opportunit__c">
      </ng-select>
    </div>
    <div class="form-group col-md-4 mb-3">
      <label for="Vendor__c" class="form-label">Vendor <i class="text-danger">*</i></label>

      <ng-select [items]="vendor$ | async" #select bindLabel="Vendor" dropdownPosition="auto" bindValue="value"
        bindLabel="label" labelForId="Vendor__c" placeholder="Vendor" [virtualScroll]="true"
        formControlName="Vendor__c">
      </ng-select>
    </div>
    <div class="form-group col-md-4 mb-3">
      <label for="Nome_servizio_a_catalogo__c" class="form-label">Servizio a catalogo <i
          class="text-danger">*</i></label>
      <ng-select [items]="serviceName$ | async" #select bindLabel="Servizio a catalogo" dropdownPosition="auto"
        bindValue="value" bindLabel="label" labelForId="Nome_servizio_a_catalogo__c" placeholder="Servizio a catalogo"
        [virtualScroll]="true" formControlName="Nome_servizio_a_catalogo__c">
      </ng-select>
    </div>
  </div>
  <div class="row">
    <div class="form-group col-md-12 mb-3">
      <label for="Descrizione_opportunit__c" class="form-label">Descrizione</label>
      <textarea class="form-control" formControlName="Descrizione_opportunit__c" id="Descrizione_opportunit__c" rows="3"
        maxlength="32768"></textarea>
    </div>
  </div>
  <div class="row">
    <div class="form-group col-md-4 mb-3">
      <label for="Valore_Opportunit__c" class="form-label">Valore Opportunità complessiva (€) <i
          class="text-danger">*</i></label>
      <input
        [class.is-invalid]="opportunityForm.get('Valore_Opportunit__c').invalid && opportunityForm.get('Valore_Opportunit__c').touched"
        type="number" class="form-control" id="Valore_Opportunit__c" placeholder="es. 5000"
        formControlName="Valore_Opportunit__c" />
    </div>
    <div class="col-md-4"></div>
    <div class="col-md-4">
      <div class="form-check pt-3">
        <input class="form-check-input" type="checkbox" formControlName="Gara__c" id="Gara__c" />
        <label class="form-check-label" for="Gara__c"> è una gara? </label>
      </div>
    </div>
  </div>
  <div class="row" *ngIf="opportunityForm.get('Gara__c').value">
    <div class="col-md-4 mb-3">
      <label for="Data_pubblicazione_Gara__c" class="form-label">Data pubblicazione Gara <i
          class="text-danger">*</i></label>
      <div class="input-group">
        <input
          [class.is-invalid]="opportunityForm.get('Data_pubblicazione_Gara__c').invalid && opportunityForm.get('Data_pubblicazione_Gara__c').touched"
          class="form-control" placeholder="dd/mm/yyyy" name="dp" id="Data_pubblicazione_Gara__c"
          formControlName="Data_pubblicazione_Gara__c" ngbDatepicker #d1="ngbDatepicker" />

        <button class="btn btn-outline-secondary bi bi-calendar3" (click)="d1.toggle()" type="button">
          <i class="fa-solid fa-calendar" aria-hidden="true"></i>
        </button>
      </div>
    </div>
    <div class="col-md-4 mb-3">
      <label for="Scadenza_domande_di_chiarimento__c" class="form-label">Scadenza domande di chiarimento <i
          class="text-danger">*</i></label>
      <div class="input-group">
        <input [class.is-invalid]="
            opportunityForm.get('Scadenza_domande_di_chiarimento__c').invalid && opportunityForm.get('Scadenza_domande_di_chiarimento__c').touched
          " class="form-control" placeholder="dd/mm/yyyy" name="dp" id="Scadenza_domande_di_chiarimento__c"
          formControlName="Scadenza_domande_di_chiarimento__c" ngbDatepicker #d2="ngbDatepicker" />

        <button class="btn btn-outline-secondary bi bi-calendar3" (click)="d2.toggle()" type="button">
          <i class="fa-solid fa-calendar" aria-hidden="true"></i>
        </button>
      </div>
    </div>
    <div class="col-md-4 mb-3">
      <label for="Scadenza_Gara__c" class="form-label">Scadenza Gara <i class="text-danger">*</i></label>
      <div class="input-group">
        <input
          [class.is-invalid]="opportunityForm.get('Scadenza_Gara__c').invalid && opportunityForm.get('Scadenza_Gara__c').touched"
          class="form-control" placeholder="dd/mm/yyyy" name="dp" id="Scadenza_Gara__c"
          formControlName="Scadenza_Gara__c" ngbDatepicker #d3="ngbDatepicker" />

        <button class="btn btn-outline-secondary bi bi-calendar3" (click)="d3.toggle()" type="button">
          <i class="fa-solid fa-calendar" aria-hidden="true"></i>
        </button>
      </div>
    </div>
  </div>
  <app-loading name="modal-spinner" [fullScreen]="true" [show]="loading || submitSubscription?.closed === false"
    class="d-absolute"></app-loading>
  <div class="row justify-content-end pt-3">
    <div class="col-auto">
      <button class="btn btn-primary" (click)="formSubmitted()">Crea opportunità</button>
    </div>
  </div>
</form>